var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedIn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 36H32C34.2091 36 36 34.2091 36 32V4C36 1.79086 34.2091 0 32 0H4C1.79086 0 0 1.79086 0 4V32C0 34.2091 1.79086 36 4 36Z",
    fill: "#263238"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28 26H23.6852V18.6509C23.6852 16.6359 22.9195 15.5099 21.3247 15.5099C19.5897 15.5099 18.6833 16.6817 18.6833 18.6509V26H14.525V12H18.6833V13.8858C18.6833 13.8858 19.9336 11.5723 22.9045 11.5723C25.874 11.5723 28 13.3857 28 17.1361V26ZM9.56416 10.1668C8.14775 10.1668 7 9.01005 7 7.58341C7 6.15676 8.14775 5 9.56416 5C10.9806 5 12.1276 6.15676 12.1276 7.58341C12.1276 9.01005 10.9806 10.1668 9.56416 10.1668ZM7.41699 26H11.753V12H7.41699V26Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedIn);
export default __webpack_public_path__ + "static/media/LinkedIn.97147732703b2f9a721169438ed79d9b.svg";
export { ForwardRef as ReactComponent };